import React from 'react';
import { Play } from 'lucide-react';
import My from '../Image/my pic.jpeg';
import { HERO_DATA } from '../utils/constants';

/**
 * Hero Section Component
 * Displays the main introduction, profile image, and call-to-action buttons.
 * Optimized for LCP with fetchPriority="high" on the main image.
 * 
 * @returns {JSX.Element} Hero section
 */
const Hero = () => {
  return (
    <div className="hero">
      <section id="home" >
        <div className="hero-content">
          <div className="hero-image">
            <div className="circle-frame">
              <img
                src={My}
                alt="Mowli S - Full Stack Software Developer"
                fetchPriority="high"
                decoding="async"
                draggable="false"
              />
            </div>
            <div className="dot dot-yellow"></div>
            <div className="dot dot-green"></div>
          </div>
          <div className="hero-text">
            <div className="greeting">{HERO_DATA.greeting}</div>
            <h1>
              <span style={{ position: 'absolute', width: '1px', height: '1px', padding: 0, margin: '-1px', overflow: 'hidden', clip: 'rect(0, 0, 0, 0)', whiteSpace: 'nowrap', border: 0 }}>
                Mowli S — 
              </span>
              {HERO_DATA.title}
            </h1>
            <p className="description">
              Full Stack Software Developer experienced in building <span className="highlight">responsive</span> and <span className="highlight">user-friendly</span> web and mobile applications using <span className="highlight">React.js</span>, <span className="highlight">Next.js</span>, <span className="highlight">Node.js</span>, <span className="highlight">PHP</span>, <span className="highlight">MongoDB</span>, <span className="highlight">MySQL</span>, <span className="highlight">React Native</span>, and <span className="highlight">Expo</span>. Focused on <span className="highlight">clean code</span>, efficient state management, <span className="highlight">performance optimization</span>, and scalable solutions.
            </p>
            <div className="cta-buttons">
              <a href="#projects" className="btn btn-secondary">
                <Play size={20} className="btn-icon" />
                <span>VIEW PROJECTS</span>
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default React.memo(Hero);